/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductStatsDto } from '../../models/product-stats-dto';

export interface ProductControllerGetStats$Params {
  id: string;
}

export function productControllerGetStats(http: HttpClient, rootUrl: string, params: ProductControllerGetStats$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductStatsDto>> {
  const rb = new RequestBuilder(rootUrl, productControllerGetStats.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductStatsDto>;
    })
  );
}

productControllerGetStats.PATH = '/api/product/{id}/stats';
